interface OnboardingStep {
  id: string;
  label: string;
}

interface OnboardingStepperProps {
  steps: readonly OnboardingStep[];
  currentStep: number;
  label: string;
}

export function OnboardingStepper({ steps, currentStep, label }: OnboardingStepperProps) {
  return (
    <nav aria-label={label} className="mb-10">
      <ol className="flex flex-nowrap items-center justify-center gap-2 overflow-x-auto">
        {steps.map((step, index) => {
          const active = index === currentStep;
          const complete = index < currentStep;
          return (
            <li className="flex shrink-0 items-center gap-2" key={step.id}>
              <div
                className={`flex items-center gap-2 whitespace-nowrap ${
                  active ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                <span
                  aria-current={active ? "step" : undefined}
                  className={`grid size-7 shrink-0 place-items-center rounded-full text-xs font-medium ${
                    active
                      ? "bg-primary text-primary-foreground"
                      : complete
                        ? "bg-primary/15 text-primary"
                        : "bg-muted text-muted-foreground"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="text-xs font-medium sm:text-sm">
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 ? (
                <span aria-hidden="true" className="h-px w-4 shrink-0 bg-border" />
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
